import {useEffect, useState} from 'react';
import {useSelector} from 'react-redux';

import useDidUpdate from '../../../hooks/useDidUpdate';
import iotDeviceConnectionStatusService from '../../../services/iotDevice/iotDeviceConnectionStatusService';
import {makeSelectDeviceConnectionStatus, makeSelectIotDeviceData} from '../../../state/selectors/iotDevice';
import {
    makeSelectIsYapDeviceInfoReceived,
    makeSelectIsYapHolderInfoReceived,
} from '../../../state/selectors/yapEncrypted';
import helpers from '../../../utils/helpers';

const useDeviceConnectionStatus = ({onReconnect, onDisconnect, isDisabled}) => {
    const connectionStatus = useSelector(makeSelectDeviceConnectionStatus());
    const isYapDeviceInfoReceived = useSelector(makeSelectIsYapDeviceInfoReceived());
    const isYapHolderInfoReceived = useSelector(makeSelectIsYapHolderInfoReceived());
    const iotDevice = useSelector(makeSelectIotDeviceData());
    const {device} = iotDevice || {};
    const {isHolderConnected} = device || {};
    const [isDevicePairedBefore, setIsDevicePairedBefore] = useState(null);
    const [isDeviceDisconnectedBefore, setIsDeviceDisconnectedBefore] = useState(true);
    const isDeviceReady = iotDeviceConnectionStatusService.isDeviceReady(connectionStatus);
    const isDeviceDisconnectedWithNoReconnect = iotDeviceConnectionStatusService.isDeviceDisconnected(connectionStatus);
    const isReady =
        isDeviceReady &&
        isYapDeviceInfoReceived &&
        (!isHolderConnected || (isHolderConnected && isYapHolderInfoReceived));

    const onConnectionStatusChange = () => {
        if (isDeviceDisconnectedWithNoReconnect) return;

        const isDevicePaired = iotDeviceConnectionStatusService.isDevicePaired(connectionStatus);
        const isDeviceConnected = iotDeviceConnectionStatusService.isDeviceConnected(connectionStatus);

        if (isDevicePaired || isDeviceConnected) {
            setIsDevicePairedBefore(true);
        }

        if (isDevicePairedBefore && !isDisabled) {
            if (isReady) {
                helpers.runFunction(onReconnect);
            } else {
                helpers.runFunction(onDisconnect);
            }
        }
    };

    useEffect(() => {
        if (isDeviceDisconnectedWithNoReconnect) {
            setIsDevicePairedBefore(false);
        }
    }, [isDeviceDisconnectedWithNoReconnect]);

    useDidUpdate(() => {
        setIsDeviceDisconnectedBefore(!isDeviceReady);

        if ((isDeviceDisconnectedBefore && !isDeviceReady) || (!isDeviceDisconnectedBefore && isDeviceReady)) return;

        onConnectionStatusChange();
    }, [isReady]);
};

export default useDeviceConnectionStatus;
